import {fetchWithState, getFetchedJSON, fetchWithStateTL} from '~/misc/fetch';
import {formatNumberOnly} from '~/misc/formatPhone';

export const getHpInfoApi = (getState) => {
  const userID = getState().user.id;
  return fetchWithStateTL(getState, {
    method: 'GET',
    url: `/${userID}/orders`,
  }).then(getFetchedJSON);
};

export const getBuyerInfoApi = (getState) => fetchWithState(getState, {
  method: 'POST',
  url: '/tl/findAccountByEmail',
}).then(getFetchedJSON);

export const getHpPlanInfoApi = (getState, options) => fetchWithStateTL(getState, {
  method: 'GET',
  header: {
    'Cache-control': 'no-cache',
    'Pragma': 'no-cache',
  },
  url: `/pay-options/customer/${options}`,
}).then(getFetchedJSON);

export const getPaymentInfosAPI = (
  getState,
  { platform = "customer", gradeOptionKey = "standar,premium,professional" }
) =>
  fetchWithState(getState, {
    url: `/tl/payOptions/${platform}/${gradeOptionKey}`,
    method: "GET",
  })
    .then(getFetchedJSON)
    .catch((error) => {
      if (error.response && error.response.status === 404) {
        throw new ActionError(error.response.statusText);
      }
      throw error;
    });;


export const createOrderApi = (getState, val) => {
  const userID = getState().user.id;
  const account_id = getState().hp.saveBsicInfo.id;
  // const ordersInfo = getState().hp.hpPaymentInfo.data ? getState().hp.hpPaymentInfo.data : [];
  // let firstOrder = true;
  // if (ordersInfo.length === 0) {
  //   firstOrder = true;
  // } else {
  //   for (let i = 0; i < ordersInfo.length; i++) {
  //     if (ordersInfo[i].status === 'success_paid') {
  //       firstOrder = false;
  //     }
  //   }
  // }

  // const url = firstOrder ? `/${userID}/vip/order` : `/${userID}/vip-add/order`;
  const url = `/${userID}/vip/order`;
  const billInfo = {
    sc: 'User',
    billing_info: {
      first_name: val.step3.formData.billFirstname || '',
      last_name: val.step3.formData.billLastname || '',
      phone: formatNumberOnly(val.step3.formData.billPhone) || '',
      email: val.step3.formData.billEmail || '',
      street_address: val.step3.formData.billAddress || '',
      city: val.step3.formData.billCity || '',
      state: val.step3.formData.billState || '',
      country: val.step3.formData.billCountry || '',
      zip: val.step3.formData.billZip || '',
    },
  };
  const reqestData = Object.assign(val.step2.formData, billInfo);

  reqestData['tl_account_id'] = account_id ? account_id : val['account_id'];

  return fetchWithStateTL(getState, {
    method: 'POST',
    url: url,
    body: reqestData,
  }).then(getFetchedJSON);
};

export const saveBsicInfoApi = (getState, val) => {
  const originPrice = Number(val.step2.formData.product.origin_price);
  const discountPrice = Number(val.step2.formData.product.discount_price);
  const seatNum = Number(val.step2.formData.product.seat_num);

  const data = {
    basicFirstName: val.step1.formData.basicFirstName || '',
    basicLastName: val.step1.formData.basicLastName || '',
    basicPhone: formatNumberOnly(val.step1.formData.basicPhone) || '',
    basicIdentity: val.step1.formData.basicIdentity || '',
    basicCompany: val.step1.formData.companyName || '',
    basicDot: val.step1.formData.companyDot || '',
    basicMc: val.step1.formData.companyMc || '',

    billCycle: val.step2.formData.product.show_name,
    unitPrice: discountPrice,
    planSave: (originPrice - discountPrice) / originPrice,
    manageUsers: seatNum,
    promotionCode: '',
    currentCost: discountPrice * seatNum,

    billFirstname: val.step3.billFirstname || '',
    billLastname: val.step3.billLastname || '',
    billPhone: formatNumberOnly(val.step3.billPhone) || '',
    billEmail: val.step3.billEmail || '',
    billAddress: val.step3.billAddress || '',
    billCity: val.step3.billCity || '',
    billState: val.step3.billState || '',
    billCountry: val.step3.billCountry || '',
    billZip: val.step3.billZip || '',
  };

  if (data.nextBillDate) {delete data.nextBillDate;}
  if (data.updateDate) {delete data.updateDate;}
  if (data.createDate) {delete data.createDate;}


  return fetchWithState(getState, {
    method: 'POST',
    url: '/tl/saveAccount',
    headerMsg: {email: false},
    body: data,
  }).then(getFetchedJSON);
};

export const getPaymentInfoApi = (getState, val) => {
  const userID = getState().user.id;
  const businessCode = val.business_code;
  const orderId = val.order_id;

  return fetchWithStateTL(getState, {
    method: 'GET',
    header: {
      'Cache-control': 'no-cache',
      'Pragma': 'no-cache',
    },
    url: `/${userID}/orders?business_code=${businessCode}&order_id=${orderId}`,
  }).then(getFetchedJSON);
};

export const payOrderApi = (getState, val) => {
  const userID = getState().user.id;
  const businessCode = getState().hp.paymentInfo.data[0].business_code;

  return fetchWithStateTL(getState, {
    method: 'POST',
    url: `/${userID}/${businessCode}/order/${val.order_id}/pay`,
    body: val,
  }).then(getFetchedJSON);
};





// WEBPACK FOOTER //
// ./src/modules/hp/api.js